import { FC, useMemo } from 'react';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Box, Divider, Grid, IconButton, Stack, Typography, useTheme } from '@mui/material';
import { PricingType } from '@prisma/client';
import { PartnerOffers } from 'types/graphql';

interface ViewOffersProps {
    offer?: PartnerOffers;
    handleClose?: () => void;
}

const ViewOffers: FC<ViewOffersProps> = ({ offer, handleClose }) => {
    const theme = useTheme();

    // Extract the products from the offers available
    const productsInTheOffer = useMemo(() => {
        if (offer?.type === PricingType.TRANSACTIONAL) {
            return;
        }
        return [...offer?.primaryProducts, ...offer?.secondaryProducts];
    }, [offer]);

    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                    backgroundColor: theme.palette.orange.main,
                    height: '64px',
                    padding: '0px 16px',
                }}
            >
                <Typography color="grey.200" fontSize={20} fontWeight={500}>
                    {offer?.name}
                </Typography>
                <IconButton data-testid="close-button" size="small" onClick={handleClose}>
                    <CloseOutlinedIcon
                        sx={{
                            color: 'grey.200',
                        }}
                    />
                </IconButton>
            </Stack>
            <Box
                sx={{
                    width: '100%',
                    padding: '16px',
                }}
            >
                <Typography color="grey.800" fontSize={20} fontWeight={500}>
                    Included in offer
                </Typography>
                <Typography color="grey.700" fontSize={16}>
                    Details
                </Typography>
                <Divider
                    sx={{
                        my: '16px',
                        borderColor: 'warning.main',
                    }}
                />
                <Grid container spacing={2}>
                    {productsInTheOffer?.map((product: any, index) => (
                        <Grid item xs={12} md={6} key={index}>
                            <Stack
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                spacing={2}
                            >
                                <Stack>
                                    <Typography key={product?.id} fontSize={16} fontWeight={500}>
                                        {product?.name}
                                    </Typography>
                                    <Typography color="grey.700" fontSize={14}>
                                        {product?.description[0]?.text}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default ViewOffers;
